module.exports = __webpack_public_path__ + "static/media/fullLogo.3b4ad788.svg";